import { useQuery } from '@tanstack/react-query'
import { buildFetch, resolveOrReject } from '@tellonym/core/api'
import { getAccessToken } from '@tellonym/core/app/selectors'
import { store } from './store'

let reactQueryClient

export const setQueryClient = (client) => {
  reactQueryClient = client
}

export const queryClient = {
  fetchQuery: async (props) => reactQueryClient?.fetchQuery(props) ?? {},
  invalidateQueries: async (props) =>
    reactQueryClient?.invalidateQueries(props) ?? {},
}

const debug = {
  all: ['debug'],
}

const fetchDebug = async () => {
  const accessToken = getAccessToken(store.getState())

  const [url, fetchConfig] = buildFetch({ path: 'debug' }, { accessToken })

  const response = await fetch(url, fetchConfig)

  return resolveOrReject(response, null, false)
}

export const useDebugQuery = () => {
  const result = useQuery(debug.all, fetchDebug)

  return result
}
